import React, {FC} from "react";
import styled from "styled-components";
import { ProfileBeaconButton } from './ProfileBeaconComponents';
import { ReactComponent as EditIcon } from 'assets/editIcon.svg';
import { CTAVariants } from "@trp-beacon-ui-kit/foundation/dist/_common/types/cta-variant";
import { ProfileBeaconIcon } from "./ProfileBeaconComponents";

interface Props {
    buttonTitle?: string;
    imageUrl?: string;
    linkTitle?: string;
    altText?: string;
    disabled?: boolean;
    onBeaconClick?: () => void;
    onClick?: () => void;
    isLink?: boolean;
    isIcon?: boolean;
    variant?:string;
}

const StyledBeaconButton = styled(ProfileBeaconButton)`
  @media only screen and (max-width: 640px) {
    width: 100%;
  }
`;

const StyledTertiaryBeaconButton = styled(ProfileBeaconButton)`
  --beacon-button-space-padding-block-start-normal: 0;
  --beacon-button-space-padding-block-end-normal: 0;
  @media only screen and (max-width: 640px) {
    width: auto;
  }
`;

const StyledSignUpBeaconButton  = styled(ProfileBeaconButton)`
  --beacon-button-font-size-normal :18px;
  --beacon-button-space-padding-block-start-normal: 0;
  --beacon-button-space-padding-block-end-normal: 0;
  @media only screen and (max-width: 768px) {
    width: auto;
    --beacon-button-font-size-normal :16px;
  }
`;

const Button: FC<Props> = ({
                               buttonTitle,
                               disabled=false,
                               isIcon,
                               onBeaconClick,
                               variant,
                               altText
                           }) => {
    return (
        <>
            {variant === "tertiary" ?
                <StyledTertiaryBeaconButton variant={variant}   disabled={disabled}
                                    onClick={onBeaconClick}>
                                        
                                        {isIcon && <EditIcon/>}
                    
                    {buttonTitle}
                  </StyledTertiaryBeaconButton>
                :
                variant === "signUp" ?
                    <StyledSignUpBeaconButton variant={CTAVariants.Tertiary}  disabled={disabled}
                                              onClick={onBeaconClick}>
                        {isIcon && <EditIcon/>}
                        {buttonTitle}
                    </StyledSignUpBeaconButton>
                    :
                  variant==="textAlerts" ?
                  <StyledBeaconButton variant ={CTAVariants.Secondary} disabled={disabled} onClick={onBeaconClick}> {buttonTitle}</StyledBeaconButton>
                  :
                <StyledBeaconButton variant={CTAVariants.Primary}   disabled={disabled}
                                    onClick={onBeaconClick}>
                                      {buttonTitle}
                </StyledBeaconButton>
            }
        </>
    );
}
export default Button;